import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import {CommonService} from '../../services/common.service';
import {UnsubscribingComponent} from '../../modules/shared/unsubscribing.component';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '../../auth/auth.service';
import {User} from '../../models/user';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent extends UnsubscribingComponent implements OnInit {
  public user: User = JSON.parse(localStorage.getItem('user'));
  public name: string;

  constructor(private router: Router,
              private commonService: CommonService,
              private translate: TranslateService,
              private authService: AuthService) {
    super();
  }

  ngOnInit(): void {
    this.authService.authenticateUser().toPromise().then(res => {
      this.user = res;
      if (res.login !== null) {
        localStorage.setItem('user', JSON.stringify(res));
        this.name = this.user.fullName;
      } else {
        this.authService.login();
      }
    });
    this.commonService.userFullName
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((name: string) => {
        this.name = name ? name : JSON.parse(localStorage.getItem('user'))?.fullName;
      });
  }

  public logout(): void {
    this.user = null;
    this.authService.logout();
  }

  public changeLanguage(): void {
    this.translate.use(this.translate.currentLang === 'sk' ? 'en' : 'sk');
    localStorage.setItem('lang', this.translate.currentLang);
  }
}
